import * as Yup from 'yup';
import { stringValidation, mustBeWholeNumber, mustBeNumber } from 'src/services/validation';
const currentYear = new Date().getFullYear();
const priorYear = currentYear - 1;

const AssetSchema = Yup.object().shape({
  itemDescr: stringValidation(),
  propCode: stringValidation(),
  yearAcq: mustBeWholeNumber({ max: priorYear }),
  purchaseCost: mustBeNumber({ min: 1 }),
  quantity: mustBeNumber({ min: 1 }),
  assetId: stringValidation({ required: false }),
  lesseeName: Yup.string()
    .trim()
    .when('isLeased', {
      is: true,
      then: Yup.string().trim().required('Required'),
      otherwise: Yup.string().trim(),
    }),
  lesseeAddr: Yup.string()
    .trim()
    .when('isLeased', {
      is: true,
      then: Yup.string().trim().required('Required'),
      otherwise: Yup.string().trim(),
    }),
  lesseeCity: Yup.string()
    .trim()
    .when('isLeased', {
      is: true,
      then: Yup.string().trim().required('Required'),
      otherwise: Yup.string().trim(),
    }),
});

export default AssetSchema;
